<template>
  <div class="page">
    <img v-for="img in imgList" v-lazy="img" :key="img" />
    <div class="page-content">
      <div class="content-item" v-for="(item, index) in datalist" :key="index">
        <div class="page-question">
          <div class="questionIcon">Q</div>
          <span class="question-title">{{ item.question }}</span>
        </div>
        <div class="page-answer">
          <div class="answerIcon">A</div>
          <div class="answer-content">
            <div v-for="(it, i) in item.answer.split('&')" :key="i">
              {{ it }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { cdnresources } from '@/util/config'
  import { homepageresources } from '@/api/company-appointment'
  import { InsuFaqQusetionsArray } from '@/util/insu-faq-questions'

  export default {
    name: 'Faq',
    filters: {},
    components: {},
    mixins: [],
    props: {},
    data() {
      return {
        cdnresources,
        imgList: [
          cdnresources + '/prod/images/xiangaibao/cjwthead.png'
          // cdnresources+'/uat/images/xiangaibao/cjwt01.png',
          // cdnresources+'/uat/images/xiangaibao/cjwt2.png',
          // cdnresources+'/uat/images/xiangaibao/cjwt03.png',
          // cdnresources+'/uat/images/xiangaibao/cjwt4.png',
        ],
        datalist: []
      }
    },
    computed: {},
    watch: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    async mounted() {
      const res = await homepageresources()
      this.datalist = InsuFaqQusetionsArray(res.goodsExt.CJWTALL)
      console.log(res.goodsExt.CJWTALL)
      console.log(this.datalist)
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {},
    methods: {}
  }
</script>
<style lang="scss" scoped>
  .page {
    display: flex;
    flex-direction: column;
    background: #f6f6f6;
    img {
      width: 100%;
    }
    .page-content {
      width: 98%;
      border: xvw(2) solid #fdece8;
      margin: xvw(40) auto;
      padding: xvw(40) xvw(40) 0;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: xvw(30);
      .content-item {
        border-bottom: xvw(2) solid #e6e6e6;
        margin-bottom: xvw(30);
        &:last-child {
          border: none;
        }
        .page-question {
          display: flex;
          margin-bottom: xvw(20);
          .questionIcon {
            width: xvw(40);
            height: xvw(40);
            text-align: center;
            line-height: xvw(40);
            color: #ffffff;
            background: #f79f64;
            border-radius: xvw(8) xvw(8) 0 xvw(8);
            margin-right: xvw(20);
          }
          .question-title {
            color: #04102b;
            font-size: px2rem(18, 375);
            font-weight: bold;
            line-height: xvw(42);
          }
        }
        .page-answer {
          display: flex;
          .answerIcon {
            flex-shrink: 0;
            width: xvw(40);
            height: xvw(40);
            text-align: center;
            line-height: xvw(40);
            color: #ffffff;
            background: #f61f1e;
            border-radius: xvw(8) xvw(8) 0 xvw(8);
            margin-right: xvw(20);
          }
          .answer-content {
            text-align: justify;
            color: #666;
            font-size: px2rem(15, 375);
            padding: xvw(20);
            border-radius: xvw(20);
            line-height: xvw(40);
          }
        }
      }
    }
  }
  .footer {
    margin-top: px2rem(80, 750);
    width: 100%;
    text-align: center;
    padding-bottom: px2rem(25, 750);
    p {
      margin: 0;
      margin-bottom: px2rem(24, 750);
      font-size: px2rem(26, 750);
      font-weight: 500;
      color: #646464;
    }
    img {
      display: block;
      width: relPercent(582, 750);
      margin: 0 auto;
    }
  }
</style>
